/*
 *
 * Whitelisting actions
 *
 */

// Constants
import {
  DEFAULT_ACTION,
  DISABLE_LOADER_ACTION,
  ENABLE_LOADER_ACTION,
  FETCH_WHITELISTING_DETAILS,
  GET_LIVENESS_DATA,
  GET_WHITELISTING_DATA,
  POST_WHITELISTING_DATA,
  UPDATE_WHITELISTING_DATA,
} from './constants';

//Types
import {
  AddToWhitelistPayloadType,
  CheckWebsiteLivePayloadType,
  FetchWhitelistingDetailsPayloadType,
  FetchWhitelistingPayloadType,
  UpdateWhitelistingPayloadType,
} from './types';

export function enableLoader(data: string) {
  return {
    type: ENABLE_LOADER_ACTION,
    data,
  };
}

export function disableLoader(data: string) {
  return {
    type: DISABLE_LOADER_ACTION,
    data,
  };
}

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function fetchWhitelistingAction(data: FetchWhitelistingPayloadType) {
  return {
    type: GET_WHITELISTING_DATA,
    data,
  };
}

export function addWhitelistingAction(data: AddToWhitelistPayloadType) {
  return {
    type: POST_WHITELISTING_DATA,
    data,
  };
}
export function updateWhitelistingAction(data: UpdateWhitelistingPayloadType) {
  return {
    type: UPDATE_WHITELISTING_DATA,
    data,
  };
}

export function checkLivenessAction(data: CheckWebsiteLivePayloadType) {
  return {
    type: GET_LIVENESS_DATA,
    data,
  };
}

export function fetchWhitelistingDetailsAction(
  data: FetchWhitelistingDetailsPayloadType,
) {
  return {
    type: FETCH_WHITELISTING_DETAILS,
    data,
  };
}
